import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";
import { showToast } from "../components/ui/toast";

// Every package, archived included — the page filters client-side
export const useGetPackagesQuery = () => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.PACKAGES],
    queryFn: () => api.get(API_ROUTES.PACKAGES),
  });

  return {
    data: data?.data?.data ?? [],
    isPending,
    isError,
    error,
  };
};

// Package rules pick from the package list too, so both refresh together.
const usePackageMutation = (mutationFn, successMessage, failureMessage) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: () => {
      showToast("success", successMessage);
    },
    onError: (err) => {
      showToast(
        "error",
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          failureMessage
      );
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [API_ROUTES.PACKAGES] });
      queryClient.invalidateQueries({
        queryKey: [API_ROUTES.GET_PACKAGE_RULE_PACKAGES],
      });
    },
  });
};

export const useCreatePackageMutation = () =>
  usePackageMutation(
    (payload) => api.post(API_ROUTES.PACKAGES, payload),
    "Package created successfully",
    "Failed to create package"
  );

export const useUpdatePackageMutation = () =>
  usePackageMutation(
    ({ _id, ...payload }) => api.put(`${API_ROUTES.PACKAGES}/${_id}`, payload),
    "Package updated successfully",
    "Failed to update package"
  );

export const useDeletePackageMutation = () =>
  usePackageMutation(
    (id) => api.delete(`${API_ROUTES.PACKAGES}/${id}`),
    "Package deleted successfully",
    "Failed to delete package"
  );

export const useRestorePackageMutation = () =>
  usePackageMutation(
    (id) => api.put(`${API_ROUTES.PACKAGES}/${id}/restore`),
    "Package restored successfully",
    "Failed to restore package"
  );
